import React from 'react';
import './App.css';
import UserList from './components/UserList';

function App() {
    
    return (
        <div>
            <h1>Lesson 19</h1>
            <fieldset>
                <legend>Application</legend>
                <UserList />
            </fieldset>
        </div>
    );
}

export default App;